import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Menu, rem } from '@mantine/core';

import { AppRoutes } from '@/router/routes.ts';

import { AppContext } from '@/contexts/AppContext/AppContextProvider';

import {
	IconBookmarks,
	IconBuilding,
	IconCar,
	IconCategory,
	IconExclamationCircle,
	IconFileCheck,
	IconShieldHalf,
} from '@tabler/icons-react';

export const ModeratorSection = () => {
	const navigate = useNavigate();
	const { admin } = useContext(AppContext);

	return (
		<>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconBookmarks style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.AllBookings)}
			>
				Все бронирования
			</Menu.Item>
			{admin && (
				<Menu.Item
					fz="md"
					fw={600}
					leftSection={<IconBuilding style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
					onClick={() => navigate(AppRoutes.Renters)}
				>
					Арендаторы
				</Menu.Item>
			)}
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconShieldHalf style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.Security)}
			>
				Охрана
			</Menu.Item>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={
					<IconExclamationCircle style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
				}
				onClick={() => navigate(AppRoutes.Restrictions)}
			>
				Нарушения
			</Menu.Item>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconFileCheck style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.RatedBookings)}
			>
				Оценённые бронирования
			</Menu.Item>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={<IconCar style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.CarAccess)}
			>
				Право проезда
			</Menu.Item>
			<Menu.Item
				fw={600}
				fz="md"
				leftSection={<IconCategory style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
				onClick={() => navigate(AppRoutes.Objects)}
			>
				Объекты
			</Menu.Item>
		</>
	);
};
